import styled from 'styled-components';
import DefaultButton from 'components/button/DefaultButton';
import { font } from 'asserts/styles/fonts';
import { color } from 'asserts/styles/colors';
import { ReactComponent as IconDownload } from 'asserts/icons/ic_download_lined.svg';
import { ReactComponent as IconPlay } from 'asserts/icons/ic_play_filled.svg';
import { useState } from 'react';
import Viewer from 'components/layer/Viewer';
import { useSetAtom } from 'jotai';
import modalInformationAtom from 'atom/modalInformationAtom';
import { useMutation } from '@tanstack/react-query';
import { restfetcher } from 'queryClient';

interface MovieListProps {
  title: string;
  attachments: FileList[];
  boardidx: number;
}

const MovieList = ({ title, attachments, boardidx }: MovieListProps) => {
  const setModalInformation = useSetAtom(modalInformationAtom);

  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const urlAttachment = attachments.find((attachment) => attachment.boardfiletype === 1);
  const linkAttachment = attachments.find((attachment) => attachment.boardfiletype === 2);
  const movieAttachment = attachments.find((attachment) => attachment.boardfiletype === 3);
  const imageAttachment = attachments.find((attachment) => attachment.boardfiletype === 4);

  // 1 썸네일, 2 첨부파일, 3. 영상파일, 4. 이미지

  const increaseViewCountApi = useMutation({
    mutationFn: (param: number) =>
      restfetcher({
        method: 'POST',
        path: 'biz/board/increase/view',
        params: {
          boardidx: param
        }
      })
  });

  const handleClickDownload = () => {
    setModalInformation({
      type: 'NOT_OPEN'
    });
  };

  const handleClickopenViewer = (boardidx: number) => {
    if (movieAttachment?.fileurl) {
      setIsViewerOpen(true);
      increaseViewCountApi.mutate(boardidx);
    } else {
      setModalInformation({
        type: 'NOT_OPEN'
      });
    }
  };

  const handleClickCloseViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <>
      <Wrapper>
        <ImageWrapper onClick={() => handleClickopenViewer(boardidx)}>
          <img
            className="thumbnail"
            src={urlAttachment?.fileurl}
            alt="영상 썸네일"
            loading="lazy"
          />
          {movieAttachment && (
            <IconWrapper>
              <IconPlay />
            </IconWrapper>
          )}
        </ImageWrapper>
        <h4>{title}</h4>
        {linkAttachment ? (
          <a href={linkAttachment?.fileurl} download target="_blank" rel="noreferrer">
            <DefaultButton
              text="PDF 다운로드"
              type="link"
              size="small"
              rightIcon={<IconDownload />}
            />
          </a>
        ) : (
          <DefaultButton
            text="PDF 다운로드"
            type="link"
            size="small"
            rightIcon={<IconDownload />}
            onClick={handleClickDownload}
          />
        )}

        {/* fileAttachment?.fileurl && */}
        {isViewerOpen && movieAttachment && (
          <Viewer
            onClose={handleClickCloseViewer}
            selectedItem={movieAttachment.fileurl}
            selectedTitle="영상"
            type={'video'}
          />
        )}
      </Wrapper>
    </>
  );
};

export default MovieList;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 435px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: fit-content;
    height: 32px;
    margin-left: auto;
    padding: 12px;
    border-radius: 24px;
    background: ${color.gray400};
    color: ${color.white2};
    text-align: center;
    ${font.caption2_medium};
  }

  h4 {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${color.black2};
    ${font.h4_medium};
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 240px;
  border-radius: 12px;
  background: ${color.gray200};
  cursor: pointer;

  img {
    width: 435px;
    height: 240px;
    border-radius: 12px;
    object-fit: cover;
  }
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  padding: 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  background: ${color.gradientType1};
`;
